export const handleResponse200 = ({
  httpResponse,
  onSuccess,
  onRecovFailure,
  onUnAuth,
  onTechnicalError
}) => {

  if (httpResponse.success) {
    onSuccess(httpResponse.payload)
  }
  else {
    if (httpResponse.statusCode === 200) {
      onRecovFailure(httpResponse.errors)
    }
    else if (httpResponse.statusCode === 401) {
      onUnAuth(['Unauthorized'])
    }
    else {
      alert(httpResponse.errors.reduce((acc, curr) => curr + ', ' + acc , ''))
    }
  }

}

export const handleAxiosNetworkError = (error) => {
  var message = ""
  if (error.response) {
    message = error.response.status + " : " + error.response.data
  }
  else if (error.request) {
    message = "Error with No Response"
  }
  else {
    message = "Errror : " + error.message
  }

  alert(message)
}